/**
 * Retired aliases which were issued after the historical customized login
 * pages had already established their organization codes. Every alias resolves
 * to the code used by the existing customized page and account namespace.
 */
const ORGANIZATION_KEY_ALIASES: Record<string, string> = {
  gp: 'twgj',
  qp: 'twgj',
  hqcc: 'geducc',
  hqyc: 'geduyc',
  hqcz: 'czhq',
  czgedu: 'czhq',
  hpwh: 'hqwh',
  gzsq: 'sbq',
  qdlq: 'landgic',
  onebest: 'wb',
  hkdse: 'hqjy',
  dyy_org: 'dyy',
  utys: 'youtop',
};

export const getCanonicalOrganizationKey = (orgKey: string): string => {
  const normalizedKey = orgKey.trim().toLowerCase();
  return ORGANIZATION_KEY_ALIASES[normalizedKey] || normalizedKey;
};

export const getBusinessLoginPath = (orgKey: string, search: string, hash: string): string => {
  return `/b/${encodeURIComponent(getCanonicalOrganizationKey(orgKey))}${search}${hash}`;
};

/** Historical /org entries use the same canonical organization code as /b. */
export const getLegacyOrganizationKey = getCanonicalOrganizationKey;

/** Returns the fixed organization key for a business login URL. */
export const getBusinessOrganizationKey = (pathname = window.location.pathname): string | null => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'b' || !segments[1]) {
    return null;
  }

  try {
    const orgKey = getCanonicalOrganizationKey(decodeURIComponent(segments[1]));
    return orgKey || null;
  } catch {
    return null;
  }
};

export const getLegacyLoginPath = (orgKey: string, search: string, hash: string): string => {
  return `/org?org=${encodeURIComponent(getCanonicalOrganizationKey(orgKey))}${search.replace(/^\?/, '&')}${hash}`;
};
